import script from "./CompleteFollowupRemarkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteFollowupRemarkModal.vue?vue&type=script&setup=true&lang=js"

import "./CompleteFollowupRemarkModal.vue?vue&type=style&index=0&id=b8d7152a&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d7152a"]])

export default __exports__